export const MAP_VIEW_PATH = "/map";
export const SEARCH_PATH = "/search";
export const PROCESS_VIEW_PATH = "/process-view";
export const PROCESS_FLOW_PATH = "/process-flow/:id";
export const LEGACY_PROCESS_VIEW_PATH = "/graph";
export const ANALYTICS_VIEW_PATH = "/analytics-view";
export const LEGACY_ANALYTICS_VIEW_PATH = "/scx-analytics";
export const ADMIN_PATH = "/admin";

export const PRIMARY_PROCESS_ROUTE_PATHS = Object.freeze([SEARCH_PATH, PROCESS_VIEW_PATH]);
export const isAdminRoutePath = (pathname = "") => pathname === ADMIN_PATH || pathname.startsWith(`${ADMIN_PATH}/`);
export const isGraphViewRoutePath = (pathname = "") =>
  PRIMARY_PROCESS_ROUTE_PATHS.includes(pathname) || pathname === LEGACY_PROCESS_VIEW_PATH || isAdminRoutePath(pathname);
